var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropDownWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7073 15.7071C12.5198 15.8946 12.2655 15.9999 12.0003 15.9999C11.7352 15.9999 11.4809 15.8946 11.2933 15.7071L5.63634 10.0501C5.54083 9.95785 5.46465 9.84751 5.41224 9.7255C5.35983 9.6035 5.33225 9.47228 5.33109 9.3395C5.32994 9.20672 5.35524 9.07504 5.40552 8.95215C5.4558 8.82925 5.53006 8.7176 5.62395 8.6237C5.71784 8.52981 5.82949 8.45556 5.95239 8.40528C6.07529 8.355 6.20696 8.32969 6.33974 8.33085C6.47252 8.332 6.60374 8.35959 6.72575 8.412C6.84775 8.46441 6.9581 8.54059 7.05034 8.6361L12.0003 13.5861L16.9503 8.6361C17.1389 8.45394 17.3915 8.35315 17.6537 8.35542C17.9159 8.3577 18.1668 8.46287 18.3522 8.64828C18.5376 8.83369 18.6427 9.0845 18.645 9.3467C18.6473 9.60889 18.5465 9.8615 18.3643 10.0501L12.7073 15.7071Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownWhite);
export default __webpack_public_path__ + "static/media/drop_down_white.081e1fbb11e072715016bfaaf5ba07c9.svg";
export { ForwardRef as ReactComponent };